import React, { useMemo } from "react";
import { useState, Fragment } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { countries } from "country-data-list";
import * as service from "./service";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import CurrentPasswordModal from "../../../Components/Modals/CurrentPasswordModal";
import CancelSubscriptionModal from "../../../Components/Modals/CancelSubscriptionModal";
import PauseSubscriptionModal from "../../../Components/Modals/PauseSubscriptionModal";
import LogoutAllModal from "../../../Components/Modals/LogoutAllModal";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import Loading from "../../../Components/Loading/Loading";
import Accounts from "./Accounts";
import PlanDetails from "./PlanDetails";
import StreamingActivity from "./StreamingActivity";
import Translate from "../../../Components/MultiLanguage/Translate";
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

const AccountSettings = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [accountDetails, setAccountDetails] = useState({});
  const [values, setValues] = useState({});
  // const [PasswordModal, setPasswordModal] = useState(false);
  const [pauseSubModal, setPauseSubModal] = useState(false);
  const [resumeLoading, setResumeLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [cancelSubModal, setCancelSubModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [profileWill, setProfileWill] = useState();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("account");
  const [activeTabName, setActiveTabName] = useState( <Translate textKey={'account_caps'} />);
  const [changedValue, setChangedValue] = useState({});

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  useEffect(() => {
    window.scroll(0, 0);
    fetchAccountDetails();
    // setCountryListOption(
    //   countries?.all?.map((item, index) => {
    //     const { alpha2, name } = item;
    //     return (
    //       <option key={index} value={alpha2}>
    //         {name}
    //       </option>
    //     );
    //   })
    // );
  }, []);

  const fetchAccountDetails = async (isUpdate) => {
    setLoading(true);
    try {
      const accountDetailsResponse = await service.getAccountDetails(appInfo);
      if (accountDetailsResponse?.status === 200) {
        setValues({
          ...values,
          email: accountDetailsResponse?.data?.data?.user_email,
          firstName: accountDetailsResponse?.data?.data?.first_name,
          lastName: accountDetailsResponse?.data?.data?.last_name,
          phone: accountDetailsResponse?.data?.data?.phone,
          country: accountDetailsResponse?.data?.data?.country_code,
        });
        setAccountDetails(accountDetailsResponse?.data?.data);
        if (isUpdate) {
          dispatch(
            getUserDetails({
              userDetails: accountDetailsResponse?.data?.data?.first_name,
            })
          );
        }
        setLoading(false);
      }
    } catch (err) {}
  };

  const handleResume = async () => {
    setResumeLoading(true);
    try {
      const response = await service.resumeSubscription(appInfo, accountDetails?.sub_id);
      if (response?.status === 200) {
        toast.success(<Translate textKey={'subscription_resume'} />, {
          position: "bottom-center",
        });
        setPauseSubModal(false);
        setAccountDetails(prev => ({ ...prev, pause_status: false }));
      } else {
        toast.error(response?.data?.message || "Failed to resume subscription.");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred.");
    } finally {
      setResumeLoading(false);
    }
  };

  const handleUpdate = (item) => {
    const { name, value } = item?.target;
    handleChange(name, value);
  };

  const handleChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
    setChangedValue({
      ...changedValue,
      [name]:value
    }) 
  };
  const handleUpdateItem = (item) =>{
    const {name,value }= item?.target;
    setValues({
      ...values,
      [name]: value,
    });
  }
  
  const onDialCodeChangeHandler = (phone_number) => {
    setValues({
      ...values,
      phone: phone_number,
    });
    setChangedValue({
      ...changedValue,
      phone: phone_number
    });
  }


  const validation = () => {
    let validationStatus = true;
    let errors = {};
    let nameRegex = /^[a-zA-Z ]{3,30}$/;
    const { firstName, lastName, country, phone } = values;

    if (!firstName) {
      errors.firstName = <Translate textKey={'first_name_required'}/>
      validationStatus = false;
    } else if (!firstName?.match(nameRegex)) {
      errors.firstName =
        <Translate textKey={'name_validation_message'}/>;
      validationStatus = false;
    }

    if (!lastName) {
      errors.lastName = <Translate  textKey={'last_name_required'}/>;
      validationStatus = false;
    } else if (!lastName?.match(nameRegex)) {
      errors.lastName =
        <Translate  textKey={'name_validation_message'}/>;
      validationStatus = false;
    }

    if (!country) {
      errors.country = <Translate  textKey={'country_required'}/>;
      validationStatus = false;
    } else if (country === <Translate textKey={'select_country'}/>) {
      errors.country = <Translate textKey={'country_required'}/>;
      validationStatus = false;
    }

    try {
      const isPhoneRequired = projectInfo?.projectConfig?.config?.REGISTRATION_PHONE_NUMBER_REQUIRED === "true";
      
      if (isPhoneRequired) {
        if (!phone || phone.trim() === "") {
          errors.phone = <Translate textKey={'phone_required'} />;
          validationStatus = false;
        } else if (phone) {
          try {
            const phoneNumberStr = phone.startsWith("+") ? phone : "+" + phone;
            const phoneNumber = parsePhoneNumber(phoneNumberStr);
            if (!phoneNumber || !phoneNumber.isValid()) {
              errors.phone = <Translate textKey={'phone_error_msg'} />;
              validationStatus = false;
            }
          } catch (e) {
            errors.phone = <Translate textKey={'phone_error_msg'} />;
            validationStatus = false;
          }
        }
      } else if (phone && phone.trim() !== "") {
        try {
          const phoneNumberStr = phone.startsWith("+") ? phone : "+" + phone;
          const phoneNumber = parsePhoneNumber(phoneNumberStr);
          if (!phoneNumber || !phoneNumber.isValid()) {
            errors.phone = <Translate textKey={'phone_error_msg'} />;
            validationStatus = false;
          }
        } catch (e) {
          errors.phone = <Translate textKey={'phone_error_msg'} />;
          validationStatus = false;
        }
      }
    } catch (e) {
      if (phone && phone.trim() !== "") {
        errors.phone = <Translate textKey={'phone_error_msg'} />;
        validationStatus = false;
      }
    }
    
    setErrors(errors);
    return validationStatus;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (validation() === true) {
      updateAccountDetails();       
     //setPasswordModal(true);       
        
      } else {
        toast.error(<Translate textKey={'check_the_fields'}/>, {
          position: "bottom-center",
        });
      }
    };
  const updateAccountDetails = async () => {
    try {
      const response = await service.updateAccountdetails(appInfo, changedValue);
      if (response?.data?.success === true) {
        toast.success(<Translate textKey={'account_updated_message'}/>, {
          position: "bottom-center",
        });
        // setPasswordModal(false);
        fetchAccountDetails(true);
      }
    } catch (err) {
      console.log("erorr", err);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  const handleFileChange = (e) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (!allowedExtensions.exec(e?.target?.files[0]?.name)) {
      alert(<Translate textKey={'invalid_extension_message'}/>);
    } else {
      const name = e?.target?.files[0]?.name;
      const files = e?.target?.files;
      setValues({
        ...values,
        file: files[0],
      });
      setChangedValue({
        ...changedValue,
        file: files[0]
      });
      setProfileWill(URL.createObjectURL(files[0]));
    }
  };

  const tabChange = (tabName) => {
    setActiveTab(tabName);
    switch (tabName) {
      case "account":
        setActiveTabName(<Translate textKey={'account_caps'}/>);
        break;
      case "plan":
        setActiveTabName(<Translate textKey={'plan_details_caps'}/>);
        break;
      case "recentDevice":
        setActiveTabName(<Translate textKey={'recent_device_streaming_activity_caps'}/>);
        break;
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="accountSettings">
      {/* {PasswordModal &&(
        <CurrentPasswordModal
          fetchAccountDetails={fetchAccountDetails}
          updateAccountDetails={updateAccountDetails}
          values={values}
          handleUpdate={handleUpdate}
          handleChange={handleChange}
          setValues={setValues}
          setErrors={setErrors}
          errors={errors}
          setPasswordModal={setPasswordModal}
          setChangedValue={setChangedValue}
          handleUpdateItem={handleUpdateItem}
        />
      )} */}
      {cancelSubModal && (
        <CancelSubscriptionModal
          fetchAccountDetails={fetchAccountDetails}
          setCancelSubModal={setCancelSubModal}
          subId={accountDetails?.sub_id}
          setPauseSubModal={setPauseSubModal}
        />
      )}
      {pauseSubModal && (
        <PauseSubscriptionModal
          setPauseSubModal={setPauseSubModal}
          subId={accountDetails?.sub_id}
          onPauseSuccess={() => {
            setAccountDetails(prev => ({ ...prev, pause_status: true }));
          }}
        />
      )}
      {logoutModal && (
        <LogoutAllModal
          setLogoutModal={setLogoutModal}
          modalType={{
            type: "logoutAll",
            heading: <Translate textKey={'sign_out_from_all_devices'}/>,
          }}
        />
      )}

      <div className="leftContainer">
        <ul className="tabs">
          <li
            className={activeTab === "account" ? "active" : "tab"}
            onClick={() => tabChange("account")}
          >
            <Translate textKey={'account_caps'}/>
          </li>
          {
            accountDetails?.sub_id &&
          <li
            className={activeTab === "plan" ? "active" : "tab"}
            onClick={() => tabChange("plan")}
          >
          <Translate textKey={'plan_details_caps'}/>
          </li>
          }
          <li
            className={activeTab === "recentDevice" ? "active" : "tab"}
            onClick={() => tabChange("recentDevice")}
          >
            <Translate textKey={'recent_device_streaming_activity_caps'}/>
          </li>
          <li onClick={()=>setLogoutModal(true)}><Translate textKey={'signout_all_device_caps'} /></li>
        </ul>
      </div>

      <div className="rightContainer">
        <div className="top">
          <h1 className="heading">{activeTabName}</h1>
        </div>
          {
            activeTab=="account" &&
        <Accounts
          profileWill={profileWill}
          accountDetails={accountDetails}
          handleFileChange={handleFileChange}
          errors={errors}
          handleUpdate={handleUpdate}
          values={values}
          setErrors={setErrors}
          onSubmitHandler={onSubmitHandler}
          onDialCodeChangeHandler={onDialCodeChangeHandler}
        />
          }
        {
          activeTab ==='plan'&&
        <PlanDetails 
          projectInfo={projectInfo} 
          accountDetails={accountDetails} 
          setCancelSubModal={setCancelSubModal} 
          setPauseSubModal={setPauseSubModal}
          pause_status={accountDetails?.pause_status}
          handleResume={handleResume}
          resumeLoading={resumeLoading}
        />
        }
        {
          activeTab === 'recentDevice' &&
          <StreamingActivity/>
        }
      </div>

      
    </div>
  );
};

export default AccountSettings;
